<template>
  <div class="pageWrap">
    <div class="pageTilte">名词解释</div>
    <div class="pageMainBox">
      <div class="oneitem titleitem">
        <div class="onelabel">名称</div>
        <div class="onetext">解释</div>
      </div>
      <div class="oneitem">
        <div class="onelabel">平台方</div>
        <div class="onetext">服装综合体</div>
      </div>
      <div class="oneitem">
        <div class="onelabel"> 商品</div>
        <div class="onetext">只到款SPU描述对象</div>
      </div>
      <div class="oneitem">
        <div class="onelabel"> 库存</div>
        <div class="onetext"> 到尺码，SKU统计对象</div>
      </div>
      <div class="oneitem">
        <div class="onelabel">供应商</div>
        <div class="onetext"> 商品的提供方</div>
      </div>
      <div class="oneitem">
        <div class="onelabel"> 销售商</div>
        <div class="onetext"> 自有销售渠道，以订单形式向系统内的供应商订购商品的企业或个人</div>
      </div>
      <div class="oneitem">
        <div class="onelabel"> 样衣</div>
        <div class="onetext"> 供应商需提供给平台方足量的样衣</div>
      </div>
      <div class="oneitem">
        <div class="onelabel"> 展厅</div>
        <div class="onetext">综合体展厅</div>
      </div>
      <div class="oneitem">
        <div class="onelabel">锁仓</div>
        <div class="onetext">销售商发起，并须供应商确认的，基于供应商的可销售库存进行明确数量的预约下单的约定行为，该约定由供应商和销售商依据平台制定的基于时间和比例规则履行</div>
      </div>
      <div class="oneitem">
        <div class="onelabel">下单（调货）</div>
        <div class="onetext">可理解为调拨商品，即由销售商发起，供应商履行，销售商确认的商品仓储关系的转移行为。下单行为一经履行确认，在没有进行该商品的最终清算前，销售商须按照平台的规则承担核销、付款的义务。</div>
      </div>
      <div class="oneitem">
        <div class="onelabel"> 核销</div>
        <div class="onetext">即销售商对已下单的商品，依据真实完成的销售量主动进行核对、确认的行为。核销须符合平台以时间、比例参数所制定的规则，核销的商品数量不满足平台规则约定的以平台制订的规则为准。</div>
      </div>
      <div class="oneitem">
        <div class="onelabel"> 付款</div>
        <div class="onetext"> 指销售商根据平台所制定的支付规则，向平台支付已核销部分商品款项的行为。</div>
      </div>
      <div class="oneitem">
        <div class="onelabel"> 结款</div>
        <div class="onetext">平台在收到销售方的款项之后，对供应商支付按一定比例扣除平台服务费的支付行为。</div>
      </div>
      <div class="oneitem">
        <div class="onelabel">清算</div>
        <div class="onetext"> 指由供应商或销售商任意一方发起并在一定时间范围内完成核销确认及货品退还数量确认的行为。</div>
      </div>
      <div class="oneitem">
        <div class="onelabel">已付款</div>
        <div class="onetext">已核销*单价</div>
      </div>

    </div>

  </div>
</template>

<script>
  import {
    ajaxPost,
    api
  } from "@/common/request.js";
  import {
    accMul,
    validateNumber
  } from "@/common/tool.js";
  export default {
    name: "platformRuleList",
    data() {
      return {};
    },
    created() {
      this.getRuleList();
    },
    methods: {

    }
  };
</script>

<style lang="scss" scoped>
  .pageWrap{padding:10px 20px;}
  .pageTilte{font-size:20px;font-weight:bold;color:#333;padding-bottom:24px;}
  .pageMainBox{background: #fff;padding:40px;}
  .oneitem{
    color:#333; border-bottom: 0.5px solid #eee;
    .onelabel{font-size: 16px;display: inline-block;vertical-align: top;width: 280px;padding:11px 23px;}
    .onetext{font-size: 16px;display: inline-block;width: 630px;padding:11px 23px;border-left: 0.5px solid #eee;}
  }
  .oneitem.titleitem{background: #F5F5F5;font-weight:bold;}
</style>



// WEBPACK FOOTER //
// src/pages/rule/explain.vue